import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "data-section-header" }
const _hoisted_2 = {
  key: 0,
  class: "cover"
}
const _hoisted_3 = { class: "data-section-content" }

import { computed, inject, toRefs, watch, ref, onMounted } from 'vue'
import InfoLabel from '@/design-system/molecules/InfoLabel.vue'
import { sharedDataKey } from '../../types'
import DashboardMissingFilter from '../components/DashboardMissingFilter.vue'
import DashboardLoading from './DashboardLoading.vue'
import DashboardMissingData from './DashboardMissingData.vue'
import { EntityLevel } from '@/composables/useEntityLevel'
import { storeToRefs } from 'pinia'
import FeatureChildren from '@/components/FeatureChildren.vue'
import { DashboardComponentType, MeasurementSource } from '@/features/dashboard'
import { useMeasurements } from '../measurements/useMeasurements'
import ToggleMenu from '@/design-system/molecules/ToggleMenu.vue'
import { Feature } from '@/pinia/feature'
import { useRouter, useRoute } from 'vue-router'
import DashboardError from './DashboardError.vue'

type Props = {
  title: string
  info?: string
  link?: { address: string; name: string }
  enabledEntityLevels?: EntityLevel[]
  measurementSources: MeasurementSource[]
  children?: Feature[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardDataSectionDynamic',
  props: {
    title: {},
    info: { default: undefined },
    link: { default: undefined },
    enabledEntityLevels: { default: () => [
    'REGION',
    'COMPLEX',
    'REAL_ESTATE',
    'CONSTRUCTION',
    'LEVEL',
    'FLOOR',
    'SPACE'
  ] },
    measurementSources: {},
    children: { default: () => [] }
  },
  setup(__props: any) {

const componentTypes = ref<string[]>(['kpi'])

const props = __props

const { measurementSources, children } = toRefs(props)

const { setMeasurements } = useMeasurements()
const router = useRouter()
const route = useRoute()
const selectedToggles = ref<string[]>([(route.query.components as string) || 'measurement'])
watch(
  () => route.query.toggle,
  (newView) => {
    selectedToggles.value = [typeof newView === 'string' ? newView : 'measurement']
  }
)
watch(
  measurementSources,
  () => {
    setMeasurements(measurementSources.value)
  },
  { immediate: true }
)

const { dataState } = storeToRefs(useMeasurements())

const existingComponentTypes = children.value
  .map((c) => c.type)
  .filter((c) => c !== undefined) as DashboardComponentType[]

const enabledToggleButtons = computed(() => {
  const buttons = ['all']
  if (existingComponentTypes.includes(DashboardComponentType.Kpi)) {
    buttons.push('measurement')
  }
  if (
    existingComponentTypes.includes(DashboardComponentType.TimeSeries) ||
    existingComponentTypes.includes(DashboardComponentType.Toplist) ||
    existingComponentTypes.includes(DashboardComponentType.Histogram)
  ) {
    buttons.push('timeseries')
  }
  if (existingComponentTypes.includes(DashboardComponentType.Heatmap)) {
    buttons.push('heatmap')
  }
  return buttons
})

const sharedData = inject(sharedDataKey)

const fullscreen = computed<boolean>(() => sharedData?.fullscreen ?? false)

function changeCards(selection: string) {
  selectedToggles.value = [selection]
  switch (selection) {
    case 'measurement':
      componentTypes.value = ['kpi']
      break
    case 'graphs':
      componentTypes.value = ['timeseries', 'toplist', 'histogram', 'barchart']
      break
    case 'heatmap':
      componentTypes.value = ['heatmap']
      break
    case 'all':
      componentTypes.value = ['kpi', 'timeseries', 'toplist', 'histogram', 'heatmap', 'barchart']
      break
  }

  router.push({ query: { ...route.query, components: selection } })
}
onMounted(() => {
  changeCards(selectedToggles.value[0])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(InfoLabel, {
        title: _ctx.title,
        info: _ctx.info,
        size: 'mediumBold',
        fullscreen: fullscreen.value
      }, null, 8, ["title", "info", "fullscreen"]),
      _createVNode(ToggleMenu, {
        selected: selectedToggles.value,
        enabledButtons: enabledToggleButtons.value,
        link: _ctx.link,
        onToggle: changeCards
      }, null, 8, ["selected", "enabledButtons", "link"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["cover-container", { covering: _unref(dataState) !== 'loaded' }])
    }, [
      (_unref(dataState) !== 'loaded')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(dataState) === 'unsupported')
              ? (_openBlock(), _createBlock(DashboardMissingFilter, { key: 0 }))
              : (_unref(dataState) === 'loading')
                ? (_openBlock(), _createBlock(DashboardLoading, { key: 1 }))
                : (_unref(dataState) === 'empty')
                  ? (_openBlock(), _createBlock(DashboardMissingData, { key: 2 }))
                  : (_unref(dataState) === 'error')
                    ? (_openBlock(), _createBlock(DashboardError, { key: 3 }))
                    : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_3, [
        _createVNode(FeatureChildren, {
          feature: "home/*/*/*/data/*",
          filter: 
          (f) =>
            f.type === undefined || (f.type !== undefined && componentTypes.value.indexOf(f.type) !== -1)
        
        }, null, 8, ["filter"])
      ])
    ], 2)
  ], 64))
}
}

})